// extracted by mini-css-extract-plugin
module.exports = {"Message":"ContactData_Message__1a3yT","ContactData":"ContactData_ContactData__20AK_","Error":"ContactData_Error__3qcxc"};